import service from '@/store/services/other-products-service';

const state = {
  list: {},
  product: false,
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_CREATED_PRODUCT: (state, product) => {
    state.product = product;
  },
};

const actions = {
  create({ rootGetters }, params) {
    return service.create(params, rootGetters["other_products/product"]).then((response) => {
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error);
    });
  },
  read({ commit }, params) {
    return service.read(params)
      .then(({ other_products }) => {
        commit('SET_LIST', other_products); 
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  update({ _ }, params) {
    return service.update(params)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  destroy({ _ }, id) {
    return service.destroy(id).then((response) => {
      return true;
    }).catch((error) => {
      return false;
    });
  },
  get({_}, id) {
    return service.get(id).then(({product}) => {
      return Promise.resolve(product);
    }).catch((error) => {
      return Promise.reject(error);
    });
  },
  setCreatedProduct({ commit }, product) {
    commit('SET_CREATED_PRODUCT', product);
  },
  getTranformerConfigs({ _ }, id) {
    return service.getTranformerConfigs(id).then(({ transformer_configs }) => {
      return Promise.resolve(transformer_configs);
    }).catch((error) => {
      return Promise.reject(error);
    });
  }
};

const getters = {
  list: state => state.list,
  product: state => state.product,
};

const other_products = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default other_products;
